<template>
  <div class="app-container">
    <Header />
    <main class="main-content">
      <router-view></router-view>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  /* padding-top: 60px; */
  flex: 1;
  /* max-width: 1200px; */
  /* margin: 0 auto; */
  /* width: 100%; */
  /* padding-left: 20px;
  padding-right: 20px; */
}
</style>
